import MarkupKitContext from 'contexts/MarkupKitContext';
import MarkupKitComp, {
  getMarkupKitComponent,
} from 'editor/components/MarkupKit';
import React, { FC, PropsWithChildren, useEffect, useState } from 'react';

type Props = PropsWithChildren<unknown>;

const MarkupKitProvider: FC<Props> = (props: Props) => {
  const { children } = props;

  const [mk, setMK] = useState<MarkupKitComp | null>(null);

  useEffect(() => {
    async function getMarkupKit() {
      const mkComp = await getMarkupKitComponent();

      setMK(mkComp);
    }

    getMarkupKit();
  }, []);

  return mk ? (
    <MarkupKitContext.Provider value={mk}>{children}</MarkupKitContext.Provider>
  ) : null;
};

export default MarkupKitProvider;
